import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { ModalServiceContext } from "./../../ricos-context/ModalContext.js";
import { useBiNext } from "./../../_shared/bi-context-provider/bi-context-provider.js";
import { useNodeAttrs } from "./../../_shared/use-node-attrs.js";
import { resolveColorsPalette } from "./../../wix-rich-content-common/index.js";
import { NewColorPicker } from "./../../ui-components/color-picker/new-color-picker/index.js";
const ButtonColorPicker = ({
  modalId,
  nodeId,
  nodeType,
  colorType,
  isHoverState,
  referenceElement,
  config,
  defaultTextColor,
  defaultBackgroundColor,
  onColorSelected,
  onColorAdded: onColorAddedProp
}) => {
  const modalService = useContext(ModalServiceContext);
  const { t } = useContext(RicosContext);
  const { pmNodeAttrs } = useNodeAttrs(nodeId, nodeType);
  const logBi = useBiNext({
    modalId,
    pluginId: nodeType === "LINK_BUTTON" ? "linkButton" : "actionButton",
    nodeId
  });
  const themeColors = resolveColorsPalette(
    config.colors ? Object.values(config.colors) : [],
    void 0,
    57
  );
  const resolveCustomColors = (args) => resolveColorsPalette(args.getColorFn?.() ?? [], args.currentColor, 57);
  const [allCustomColors, setAllCustomColors] = useState(() => ({
    textColor: resolveCustomColors({
      currentColor: pmNodeAttrs?.styles?.textColor ?? defaultTextColor,
      getColorFn: config.getTextColors
    }),
    borderColor: resolveCustomColors({
      currentColor: pmNodeAttrs?.styles?.borderColor ?? defaultBackgroundColor,
      getColorFn: config.getBorderColors
    }),
    backgroundColor: resolveCustomColors({
      currentColor: pmNodeAttrs?.styles?.backgroundColor ?? defaultBackgroundColor,
      getColorFn: config.getBackgroundColors
    })
  }));
  const onColorAdded = (color) => {
    onColorAddedProp(color);
    setAllCustomColors((prev) => ({ ...prev, [colorType]: [...prev[colorType], color] }));
    onColorSelected(color);
  };
  const closeModal = () => modalService.closeModal(modalId);
  const onResetColor = () => onColorSelected(void 0);
  const currentColor = pmNodeAttrs?.styles?.[`${colorType}${isHoverState ? "Hover" : ""}`]?.toUpperCase();
  const customColors = allCustomColors[colorType];
  return /* @__PURE__ */ React.createElement(
    NewColorPicker,
    {
      themeColors,
      customColors,
      currentColor,
      title: t("ButtonColourModal_Title"),
      closeModal,
      onColorSelected,
      onColorAdded,
      onResetColor,
      referenceElement,
      logBi
    }
  );
};
export {
  ButtonColorPicker
};
//# sourceMappingURL=button-color-picker.js.map
